<template>
    <modal id="profile-modal" ref="modal" style="z-index: 9999" class="fade" dialog="modal-xl" :needHeader="false"
           :needFooter="true">
        <template v-slot:header>
            <div class="w-100 pe-3 text-truncate" v-if="profile">

                <div class="fw-bolder h5 text-truncate lh-1 m-0">{{ profile.title }}</div>
            </div>
            <button type="button" @click="$refs.modal.close()" class="btn-close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
        </template>
        <div ref="profile">
            <button type="button" @click="$refs.modal.close()" class="btn-close p-close d-none d-lg-block"
                    data-bs-dismiss="modal"
                    aria-label="Close"></button>
            <circle-btn @click="$refs.modal.close()" class="close-btn d-block d-sm-none">
                <i class="fa-regular fa-xmark"></i>
            </circle-btn>
            <tracker
                v-if="profile?.token"
                :key="profile.token"
                :token="profile.token"
                :active="modalVisible"
                :min="5"
            />
            <div v-if="profile" v-html="profile.view"></div>
            <spinner1 v-else></spinner1>
        </div>
    </modal>
</template>

<script>
import shareButtons from "./share";
import {createApp} from 'vue';
import Share from "../../templates/search/components/share";
import Tracker from "../tracker.vue";

export default {
    name: "profile-modal",
    inject: ['helper'],
    data() {
        return {
            profile: null,
            sm: null,
            video: null,
            manager: null,
            _keyHandler: null,
            modalVisible: false,
        }
    },
    components: {
        Tracker,
        phone: require('../../templates/directory/components/phone').default,
        spinner1: require('%/spinner/spinner1').default,
        circleBtn: require('%/btn/circle-btn').default,
    },
    computed: {},
    mounted() {
        emitter.on('openProfileModal', (id) => {
            this.profile = null;
            $api.app.getProfile(id).then(resp => {
                this.profile = resp.data;
                this.open();

                setTimeout(() => {
                    createApp(shareButtons, {userID: resp.data.user_id}).mount('#share');
                    this.video = jQuery('#p-video', {profile: resp.data}).get(0);
                    if (this.video) {
                        this.video.play();
                    }
                    let self = this;
                    if (this.profile.can_edit) {
                        jQuery('[data-edit]').click(function () {
                            let action = jQuery(this).attr('data-edit');
                            self.$refs.modal.close();
                            self.$router.push('/edit/' + self.profile.user_id + '?edit=' + action);
                        });
                    }

                    if (this.profile.can_edit) {
                        jQuery('[data-media]').click(function () {
                            if (confirm('delete?')) {
                                let mid = jQuery(this).data('media');
                                console.log('delete ' + mid);
                                $api.edit.setAttribute(self.profile.user_id, {id: mid, name: 'deleteMedia'}).then(resp => {
                                    jQuery('#photo-' + mid).remove();
                                })
                            }
                        });

                        jQuery('[data-video]').click(function () {
                            if (confirm('delete video?')) {
                                $api.edit.deleteVideo(self.profile.user_id).then(resp => {
                                    jQuery('#p-video').remove();
                                });
                            }
                        });
                    }

                    jQuery('.bookmark').click(function () {
                        var user_id = jQuery(this).attr('id');
                        var ls = window.localStorage.getItem('bookmarks');
                        if (ls) {
                            var bookmarks = JSON.parse(window.localStorage.getItem('bookmarks'));
                        } else {
                            var bookmarks = [];
                        }
                        bookmarks = bookmarks.filter(Number).filter(function (el) {
                            return el != 0;
                        });
                        if (bookmarks.includes(user_id)) {
                            if (confirm('Remove from bookmarks?')) {
                                var index = bookmarks.indexOf(user_id)
                                bookmarks.splice(index, 1);
                            }
                        } else {
                            if (confirm('Bookmark?')) {
                                bookmarks.unshift(user_id);
                            }
                        }
                        window.localStorage.setItem('bookmarks', JSON.stringify(bookmarks));
                    });

                    if (!this.manager) {
                        this.manager = new Hammer.Manager(this.$refs.profile, {touchAction: 'pan-y'});
                        let Swipe = new Hammer.Swipe();
                        this.manager.add(Swipe);
                        this.manager.on('swiperight', (e) => {
                            console.log('next')
                            emitter.emit('loadProfile', {user_id: this.profile.user_id, direction: '+'});
                        });
                        this.manager.on('swipeleft', (e) => {
                            console.log('prev')
                            emitter.emit('loadProfile', {user_id: this.profile.user_id, direction: '-'});
                        });

                        this._keyHandler = (e) => {
                            if (document.activeElement && document.activeElement.tagName === 'INPUT') return;
                            if (e.key === 'ArrowRight') {
                                emitter.emit('loadProfile', {user_id: this.profile.user_id, direction: '+'});
                            } else if (e.key === 'ArrowLeft') {
                                emitter.emit('loadProfile', {user_id: this.profile.user_id, direction: '-'});
                            }
                        };
                        window.addEventListener('keydown', this._keyHandler);
                    }
                }, 250);
            })
        })

        this.$refs.modal.$refs.modal.addEventListener('shown.bs.modal', () => {
            this.modalVisible = true;
        });

        this.$refs.modal.$refs.modal.addEventListener('hidden.bs.modal', () => {
            this.modalVisible = false;

            if (this.sm) {
                this.sm.destroy();
            }

            if (this.video) {
                this.video.pause()
            }
        });
    },
    beforeUnmount() {
        emitter.off('openProfileModal');
        if (this._keyHandler) {
            window.removeEventListener('keydown', this._keyHandler);
        }
        if (this.manager) {
            this.manager.destroy();
            this.manager = null;
        }
    },
    methods: {
        gotoNextPage() {
            const url = new URL(window.location.href);
            let page = parseInt(url.searchParams.get('page') || '1', 10);
            url.searchParams.set('page', page + 1);
            window.location.href = url.toString();
        },

        edit(attr = false) {
            this.$refs.modal.close();
            this.$router.push('/edit/' + this.profile.user_id)
        },
        open() {
            this.$refs.modal.open();
            setTimeout(() => {
                this.sm = new SmartPhoto(".gallery-photo");
                try {
                    window.initGmediaWidget();
                    console.log('init gmedia');
                } catch (e) {
                    console.log(e)
                }
            }, 150);
        },
    }
}
</script>
<style lang="scss">
#profile-modal {
    .close-btn {
        position: fixed;
        z-index: 3;
        bottom: 20px;
        left: 18px;
    }

    .modal-body {
        padding: 0.25rem;
    }

    .p-close {
        position: absolute;
        z-index: 3;
        right: 10px;
        top: 10px;
    }

    @media (max-width: 575.98px) {
        .modal-body {
            padding: 0.5rem;
        }

        .modal-header {
            padding: 0.5rem;
        }
    }
}
</style>
